import PrescribersPage from './PrescribersPage'

export default PrescribersPage
